// Datums- und Zeithilfen. Alle Daten sind lokale Kalenderdaten ('YYYY-MM-DD'),
// Zeitpunkte als 'YYYY-MM-DD HH:MM' – lexikografisch vergleichbar.
import type { Datum, Uhrzeit } from './typen';

const pad = (n: number) => String(n).padStart(2, '0');

export function zuDate(d: Datum): Date {
  const [j, m, t] = d.split('-').map(Number);
  return new Date(j, m - 1, t, 12, 0, 0);
}
export function ausDate(x: Date): Datum {
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
}
export function heute(): Datum { return ausDate(new Date()); }
export function plusTage(d: Datum, n: number): Datum {
  const x = zuDate(d); x.setDate(x.getDate() + n); return ausDate(x);
}
/** 0 = Montag … 6 = Sonntag */
export function wochentag(d: Datum): number { return (zuDate(d).getDay() + 6) % 7; }
export function montag(d: Datum): Datum { return plusTage(d, -wochentag(d)); }
export function kw(d: Datum): number {
  const x = zuDate(d);
  const t = new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate()));
  const tag = t.getUTCDay() || 7;
  t.setUTCDate(t.getUTCDate() + 4 - tag);
  const jahresanfang = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
  return Math.ceil(((t.getTime() - jahresanfang.getTime()) / 86400000 + 1) / 7);
}
export function tageZwischen(a: Datum, b: Datum): number {
  return Math.round((zuDate(b).getTime() - zuDate(a).getTime()) / 86400000);
}

const TAGE_KURZ = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
const TAGE_LANG = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
const MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export const tagKurz = (d: Datum) => TAGE_KURZ[wochentag(d)];
export const tagLang = (d: Datum) => TAGE_LANG[wochentag(d)];
export function deKurz(d: Datum): string { const [, m, t] = d.split('-'); return `${t}.${m}.`; }
export function deLang(d: Datum): string { const [j, m, t] = d.split('-'); return `${t}.${m}.${j}`; }
export function monatName(m: number) { return MONATE[m]; }

export function zeitpunkt(d: Datum, u: Uhrzeit): string { return `${d} ${u.slice(0, 5)}`; }
export function ueberschneidet(aVon: string, aBis: string, bVon: string, bBis: string): boolean {
  return aVon < bBis && bVon < aBis;
}
export function minuten(u: Uhrzeit): number { const [h, m] = u.split(':').map(Number); return h * 60 + m; }
export function uhr(min: number): Uhrzeit { return `${pad(Math.floor(min / 60))}:${pad(min % 60)}`; }
export const kurzeZeit = (u: Uhrzeit) => u.slice(0, 5);

export function istWochenende(d: Datum) { return wochentag(d) >= 5; }
